/**
 * @author Matheus Vieira <matheus.vieira@deal.com.br>
 * @since 2020-11-26
 */
const formatterPhone = pn => {
  return `(${pn.substr(0, 2)}) 9 **** ${pn.substr(3, 4)}`;
};

export default formatterPhone;
